import React, { useState } from 'react';
import { Button, showToast } from '@attentive-platform/stem-ui';
import FalconUserAssignModal from './FalconUserAssignModal';
import { fetchApiData } from '../../Utils/ApiCalls';
import { interpolate } from '../../Utils/ApiCalls';
import { PORTFOLIO_EXECUTE } from '../../urls';
import { PORTFOLIO_REVIEW_ENUM } from '../../Constants/Constants';

const PortfolioRequestBtns = ({ selectedRows, refetchData, portfolioId, isFetching }) => {
  const [show, setShow] = useState(false);

  const handleFlockClick = async () => {
    try {
      await fetchApiData({
        endpoint: interpolate(PORTFOLIO_EXECUTE, [portfolioId]),
        apiRequest: 'POST',
        data: {
          execute_on: PORTFOLIO_REVIEW_ENUM.FLOCK,
          selected_rows: selectedRows
        }
      });
      showToast('Portfolio review for Flock started successfully', 'success');
      await refetchData();
    } catch (error) {
      showToast('Something went wrong', 'error');
    }
  };

  return (
    <>
      <div>
        <Button size='medium' variant='outlined' color='primary' loading={isFetching} onClick={() => setShow(true)}>
          Run on Falcon
        </Button>
        <Button
          className='ml-2'
          variant='outlined'
          size='medium'
          color='primary'
          loading={isFetching}
          onClick={handleFlockClick}>
          Run on Flock
        </Button>
      </div>

      {show && (
        <FalconUserAssignModal
          show={show}
          setShow={setShow}
          refetchData={refetchData}
          selectedRows={selectedRows}
          portfolioId={portfolioId}
        />
      )}
    </>
  );
};

export default PortfolioRequestBtns;
